import React, { useEffect, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  carrentBookingList,
  fetchAllMyBookings,
  flightBookingList,
  getTripLoading,
  hotelBookingList,
  transferBookingList,
} from "../../../features/allBookingSlice";
import Loader from "../../../helpers/Loader";
import HotelItem from "./withDetailItems/HotelItem";
import TransferItem from "./withDetailItems/TransferItem";
import DetailModal from "./DetailModal";
import NoData from "./NoData";
import CarrentItem from "./withDetailItems/CarrentItem";
import CarrentCancelled from "./cancelledItems/CarrentCancelled";
import TransferCancelled from "./cancelledItems/TransferCancelled";
import HotelCancelled from "./cancelledItems/HotelCancelled";
import { scrollFunc } from "../../../helpers/helper";
import { useLocation, useNavigate } from "react-router-dom";
import FlightItem from "./withDetailItems/FlightItem";
import FlightCancelled from "./cancelledItems/FlightCancelled";

const Trip = () => {
  const dispatch = useDispatch();
  const checkref = React.useRef(true);
  const scrolltoview = useRef(null);
  const [tripType, setTripType] = useState("all");
  const { state } = useLocation();

  // const [carrentalList, setCarrentalList] = useState([]);

  const [hotelConfirmed, setHotelConfirmed] = useState([]);
  const [transferConfirmed, setTransferConfirmed] = useState([]);
  const [carrentConfirmed, setCarrentConfirmed] = useState([]);
  const [flightConfirmed, setFlightConfirmed] = useState([]);

  const [hotelPending, setHotelPending] = useState([]);
  const [transferPending, setTransferPending] = useState([]);
  const [carrentPending, setCarrentPending] = useState([]);
  const [flightPending, setFlightPending] = useState([]);
  //
  const [carrentCancelled, setCarrentCancelled] = useState([]);
  const [transferCancelled, setTransferCancelled] = useState([]);
  const [hotelCancelled, setHotelCancelled] = useState([]);
  const [flightCancelled, setFlightCancelled] = useState([]);

  const [bookingType, setBookingType] = useState("pending");

  const [show, setShow] = useState(false);
  const [deleting, setDeleting] = useState("");
  const [change, setChange] = useState(false);

  const [modalData, setModalData] = useState([]);
  const [detailType, setDetailType] = useState("");

  const loading = useSelector(getTripLoading);
  const hotelList = useSelector(hotelBookingList);
  const transferList = useSelector(transferBookingList);
  const carrentList = useSelector(carrentBookingList);

  const flightList = useSelector(flightBookingList);

  const { Authorization } =
    (sessionStorage.getItem("userData") !== null &&
      JSON.parse(sessionStorage.getItem("userData"))) ||
    {};

  const checkRef = React.useRef(true);

  const userData = JSON.parse(sessionStorage.getItem("userData")) || [];
  // useSelector((state) => state.user.userData, shallowEqual);
  const navigate = useNavigate();

  useEffect(() => {
    if (state?.location !== null && state?.location !== undefined) {
      setTripType(state?.location);
      setBookingType(state?.type);
    } else {
      setTripType("all");
      setBookingType("confirmed");
    }
  }, [state]);

  React.useEffect(() => {
    // setTimeout(())
    if (userData.length === 0) {
      navigate("/");
    }
  }, [userData]);

  useEffect(() => {
    // if (checkref.current === true) {
    setHotelConfirmed([]);
    setTransferConfirmed([]);
    setCarrentConfirmed([]);

    setHotelPending([]);
    setTransferPending([]);
    setCarrentPending([]);

    setHotelCancelled([]);
    setTransferCancelled([]);
    setCarrentCancelled([]);

    dispatch(fetchAllMyBookings(Authorization));
    setShow(false);
    // }
    // return () => {
    //   checkref.current = false;
    // };
  }, [change]);

  useEffect(() => {
    var hotelConfirmed = [];
    var hotelPending = [];
    var hotelCancelled = [];
    hotelList?.map((ele) => {
      switch (ele.status) {
        case "1":
          hotelConfirmed.push(ele);
          break;
        case "0":
          hotelPending.push(ele);
          break;
        case "2":
          hotelCancelled.push(ele);
          break;
        default:
          return;
      }
    });

    setHotelConfirmed(hotelConfirmed);
    setHotelCancelled(hotelCancelled);
    setHotelPending(hotelPending);

    var transferConfirmed = [];
    var transferPending = [];
    var transferCancelled = [];

    transferList?.length > 0 &&
      transferList?.map((ele) => {
        switch (ele.status) {
          case "1":
            transferConfirmed.push(ele);
            break;
          case "0":
            transferPending.push(ele);
            break;
          case "2":
            transferCancelled.push(ele);
            break;
          default:
            return;
        }
      });

    setTransferConfirmed(transferConfirmed);
    setTransferCancelled(transferCancelled);
    setTransferPending(transferPending);

    var carrentConfirmed = [];
    var carrentPending = [];
    var carrentCancelled = [];

    carrentList?.map((ele) => {
      switch (ele.status) {
        case "1":
          carrentConfirmed.push(ele);
          break;
        case "0":
          carrentPending.push(ele);
          break;
        case "2":
          carrentCancelled.push(ele);
          break;
        default:
          return;
      }
    });

    setCarrentConfirmed(carrentConfirmed);
    setCarrentPending(carrentPending);
    setCarrentCancelled(carrentCancelled);

    var flightConfirmed = [];
    var flightPending = [];
    var flightCancelled = [];

    flightList?.map((ele) => {
      switch (ele.status) {
        case "1":
          flightConfirmed.push(ele);
          break;
        case "0":
          flightPending.push(ele);
          break;
        case "2":
          flightCancelled.push(ele);
          break;
        default:
          return;
      }
    });

    setFlightCancelled(flightCancelled);
    setFlightPending(flightPending);
    setFlightConfirmed(flightConfirmed);

    // setHotelConfirmed(hotelList.filter((ele) => ele.status === "1"));
    // setTransferConfirmed(transferList.filter((ele) => ele.status === "1"));
    // setCarrentConfirmed(carrentList.filter((ele) => ele.status === "1"));

    // // setHotelPending(hotelList.filter((ele) => ele.status === "0"));
    // setTransferPending(transferList.filter((ele) => ele.status === "0"));
    // setCarrentPending(carrentList.filter((ele) => ele.status === "0"));
    // //
    // // setCarrentCancelled(carrentList.filter((ele) => ele.status === "2"));
    // setTransferCancelled(transferList.filter((ele) => ele.status === "2"));
    // setHotelCancelled(hotelList.filter((ele) => ele.status === "2"));

    // setAllConfirmed(arr);
    scrolltoview.current?.scrollIntoView({ behavior: "smooth" });
  }, [carrentList, hotelList, carrentList, transferList, change, tripType]); //

  const handleSelectChange = (e) => {
    setTripType(e.target.value);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <section className="booking" ref={scrolltoview}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-tab-wrapper">
                <div className="tabs-wrapper">
                  <ul className="nav nav-tabs border-0" role="tablist">
                    <li className="nav-item">
                      <a
                        className={
                          bookingType === "pending"
                            ? "nav-link active"
                            : "nav-link"
                        }
                        data-bs-toggle="tab"
                        href="#upcoming-bookings"
                      >
                        {" "}
                        <div className="tab-icon-img">
                          <img src="assets/images/my-trip/icon1.svg" alt="" />
                        </div>{" "}
                        Not Confirmed Bookings
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          bookingType === "cancelled"
                            ? "nav-link active"
                            : "nav-link"
                        }
                        data-bs-toggle="tab"
                        href="#cancelled-booking"
                      >
                        {" "}
                        <div className="tab-icon-img">
                          <img src="assets/images/my-trip/icon2.svg" alt="" />
                        </div>{" "}
                        Cancelled Booking
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className={
                          bookingType === "confirmed"
                            ? "nav-link active"
                            : "nav-link"
                        }
                        data-bs-toggle="tab"
                        href="#completed-booking"
                      >
                        {" "}
                        <div className="tab-icon-img">
                          <img src="assets/images/my-trip/icon3.svg" alt="" />
                        </div>{" "}
                        Completed Bookings
                      </a>
                    </li>

                    <div className="booking-detail-select">
                      <div className="dropdown notification-dropdown">
                        <select
                          onChange={handleSelectChange}
                          defaultValue={tripType}
                        >
                          <option value="all">All</option>
                          <option value="hotel">Hotel</option>
                          <option value="transfer">Transfer</option>
                          <option value="carrent">Car Rental</option>
                          <option value="flight">Flight</option>
                        </select>
                      </div>
                    </div>
                  </ul>
                </div>

                <div className="tab-content">
                  <div
                    id="upcoming-bookings"
                    className={
                      bookingType === "pending"
                        ? "tab-pane fade active show"
                        : "tab-pane fade"
                    }
                  >
                    {hotelPending.length === 0 && tripType === "hotel" ? (
                      <NoData />
                    ) : (
                      hotelPending.map((ele, ind) => {
                        if (tripType === "hotel" || tripType === "all") {
                          return (
                            <HotelItem
                              val={ele}
                              key={ind}
                              setShow={setShow}
                              setModalData={setModalData}
                              setDetailType={setDetailType}
                              setDeleting={setDeleting}
                            />
                          );
                        }
                      })
                    )}

                    {transferPending.length === 0 && tripType === "transfer" ? (
                      <NoData />
                    ) : (
                      transferPending.map((ele, ind) => {
                        if (tripType === "transfer" || tripType === "all") {
                          return (
                            <TransferItem
                              val={ele}
                              key={ind}
                              setShow={setShow}
                              setModalData={setModalData}
                              setDetailType={setDetailType}
                              setDeleting={setDeleting}
                            />
                          );
                        }
                      })
                    )}

                    {carrentPending.length === 0 && tripType === "carrent" ? (
                      <NoData />
                    ) : (
                      carrentPending.map((ele, ind) => {
                        if (tripType === "carrent" || tripType === "all") {
                          return (
                            <CarrentItem
                              val={ele}
                              key={ind}
                              setShow={setShow}
                              setModalData={setModalData}
                              setDetailType={setDetailType}
                              setDeleting={setDeleting}
                            />
                          );
                        }
                      })
                    )}

                    {flightPending.length === 0 && tripType === "flight" ? (
                      <NoData />
                    ) : (
                      flightPending.map((ele, ind) => {
                        if (tripType === "flight" || tripType === "all") {
                          return (
                            <FlightItem
                              val={ele}
                              key={ind}
                              setShow={setShow}
                              setModalData={setModalData}
                              setDetailType={setDetailType}
                              setDeleting={setDeleting}
                            />
                          );
                        }
                      })
                    )}

                    {tripType === "all" &&
                      hotelPending.length === 0 &&
                      transferPending.length === 0 &&
                      carrentPending.length === 0 &&
                      flightPending.length === 0 && <NoData />}
                  </div>
                  <div
                    id="cancelled-booking"
                    className={
                      bookingType === "cancelled"
                        ? "tab-pane fade active show"
                        : "tab-pane fade"
                    }
                  >
                    {hotelCancelled.length === 0 && tripType === "hotel" ? (
                      <NoData />
                    ) : (
                      hotelCancelled.map((ele, ind) => {
                        if (tripType === "hotel" || tripType === "all") {
                          return <HotelCancelled val={ele} key={ind} />;
                        }
                      })
                    )}
                    {transferCancelled.length === 0 &&
                    tripType === "transfer" ? (
                      <NoData />
                    ) : (
                      transferCancelled.map((ele, ind) => {
                        if (tripType === "transfer" || tripType === "all") {
                          return <TransferCancelled val={ele} key={ind} />;
                        }
                      })
                    )}
                    {carrentCancelled.length === 0 && tripType === "carrent" ? (
                      <NoData />
                    ) : (
                      carrentCancelled.map((ele, ind) => {
                        if (tripType === "carrent" || tripType === "all") {
                          return <CarrentCancelled val={ele} key={ind} />;
                        }
                      })
                    )}

                    {flightCancelled.length === 0 && tripType === "flight" ? (
                      <NoData />
                    ) : (
                      flightCancelled.map((ele, ind) => {
                        if (tripType === "flight" || tripType === "all") {
                          return <FlightCancelled val={ele} key={ind} />;
                        }
                      })
                    )}

                    {tripType === "all" &&
                      hotelCancelled.length === 0 &&
                      transferCancelled.length === 0 &&
                      carrentCancelled.length === 0 &&
                      flightCancelled.length === 0 && <NoData />}
                  </div>
                  <div
                    id="completed-booking"
                    className={
                      bookingType === "confirmed"
                        ? "tab-pane fade active show"
                        : "tab-pane fade"
                    }
                  >
                    <div className="row">
                      {hotelConfirmed.length === 0 && tripType === "hotel" ? (
                        <NoData />
                      ) : (
                        hotelConfirmed.map((ele, ind) => {
                          if (tripType === "hotel" || tripType === "all") {
                            return (
                              <HotelItem
                                val={ele}
                                key={ind}
                                setShow={setShow}
                                setModalData={setModalData}
                                setDetailType={setDetailType}
                                setDeleting={setDeleting}
                              />
                            );
                          }
                        })
                      )}
                      {transferConfirmed.length === 0 &&
                      tripType === "transfer" ? (
                        <NoData />
                      ) : (
                        transferConfirmed.map((ele, ind) => {
                          if (tripType === "transfer" || tripType === "all") {
                            return (
                              <TransferItem
                                val={ele}
                                key={ind}
                                setShow={setShow}
                                setModalData={setModalData}
                                setDetailType={setDetailType}
                                setDeleting={setDeleting}
                              />
                            );
                          }
                        })
                      )}

                      {carrentConfirmed.length === 0 &&
                      tripType === "carrent" ? (
                        <NoData />
                      ) : (
                        carrentConfirmed.map((ele, ind) => {
                          if (tripType === "carrent" || tripType === "all") {
                            return (
                              <CarrentItem
                                val={ele}
                                key={ind}
                                setShow={setShow}
                                setModalData={setModalData}
                                setDetailType={setDetailType}
                                setDeleting={setDeleting}
                              />
                            );
                          }
                        })
                      )}
                      {/*  */}
                      {flightConfirmed.length === 0 && tripType === "flight" ? (
                        <NoData />
                      ) : (
                        flightConfirmed.map((ele, ind) => {
                          if (tripType === "flight" || tripType === "all") {
                            return (
                              <FlightItem
                                val={ele}
                                key={ind}
                                setShow={setShow}
                                setModalData={setModalData}
                                setDetailType={setDetailType}
                                setDeleting={setDeleting}
                              />
                            );
                          }
                        })
                      )}
                    </div>
                    {/*  */}
                    {tripType === "all" &&
                      hotelConfirmed.length === 0 &&
                      transferConfirmed.length === 0 &&
                      carrentConfirmed.length === 0 &&
                      flightConfirmed.length === 0 && <NoData />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {show ? (
        <DetailModal
          show={show}
          setShow={setShow}
          detailType={detailType}
          modalData={modalData}
          checkRef={checkRef}
          deleting={deleting}
          setDeleting={setDeleting}
          setModalData={setModalData}
          change={change}
          setChange={setChange}
          setTripType={setTripType}
        />
      ) : null}
    </>
  );
};

export default Trip;
